<template>
  <div id="app">
    <div class="header">
      <div class="title">
        <a class="logo" href="/">Tinkervel</a> is little online editor for laravel.
      </div>
      <ul class="nav">
        <li v-if="auth">
          <a href="/logout" >Logout</a>
        </li>
        <li v-else>
          <a href="/oauth-github" >Login</a>
        </li>
        <li>
          <a href="/list" >History</a>
        </li>


        <li>
          <a href="https://tinkervel.anotion.so/" target="_blank">About</a>
        </li>

        <li>
          <a href="https://tinkervel.anotion.so/faq" target="_blank">FAQ</a>
        </li>
        <li>
          <a href="https://tinkervel.anotion.so/term" target="_blank">Term</a>
        </li>
      </ul>
    </div>
    <div class="main">
      <splitPane  :min-percent='10' :default-percent='70' split="vertical">
        <template slot="paneL">
          <splitPane  :min-percent='10' :default-percent='50' split="horizontal">
            <template slot="paneL">
              <div class="height100">
                <div class="filename">
                  Execution script
                  <input type="text" v-model="script.title" placeholder="script tittle here" class="script_title" >
                </div>
                <codemirror v-model="script.main_script" :options="codeMirrorOptions"/>
              </div>
            </template>
            <template slot="paneR">
              <div class="height100">
                <div class="filename">Extra script</div>
                <codemirror v-model="script.sub_script" :options="codeMirrorOptions"/>
              </div>
            </template>
          </splitPane>
        </template>
        <template slot="paneR">
          <splitPane  :min-percent='100' :default-percent='100' split="horizontal">
            <template slot="paneL">
              <div class="height100">
                <div class="filename">
                  Result
                  <div class="buttons">
                    <a :href="twitterLink" target="_blank" v-if="script.uuid">Tweet</a>
                    <button @click="run(false)">Run</button>
                    <button @click="save">Save</button>
                  </div>
                </div>
                <textarea class="result" readonly v-model="script.result">

                </textarea>
              </div>
            </template>

          </splitPane>
        </template>
      </splitPane>
    </div>
  </div>
</template>

<script>

  import VueCodemirror from 'vue-codemirror'
  import splitPane from 'vue-splitpane'
  import axios from "axios";


  import 'codemirror/mode/php/php.js'
  import 'codemirror/theme/monokai.css'
  import 'codemirror/lib/codemirror.css'
  import Vue from 'vue';
  Vue.use(VueCodemirror)

export default {
  name: 'App',
  computed: {
    twitterLink() {
      return 'https://twitter.com/intent/tweet?hashtags=tinkervel,laravel&url=https://tinkervel.com/'+this.script.uuid
    }
  },
  data()
  {
    return {
      auth:null,
      mainScript:'<'+'?php echo "hello world";',
      script:{
        result:''
      },
      codeMirrorOptions: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        matchBrackets: true,
        line: true,
        mode: 'javascript',
        lineWrapping: true,
        theme: 'monokai'
      }
    }
  },
  methods: {
    async save(){
      if (!this.script.uuid) {
        if (confirm("Save anonymous (public)?. \n Do not include copyrighted material and personal data")) {
          this.run(true)
        } else {
          this.run(false)
        }
      } else {
        this.run(true)
      }
    },
    async run(doSave) {
      this.script.result = 'Running.';
      const timer = setInterval(() => {
        this.script.result+='.'
      }, 300)
      const meta = document.querySelector('meta[name="csrf-token"]')
      const csrf = meta ? meta.getAttribute('content') : 'dummy'
      const res = this.script.result = (await axios.post('/script', {
        _token:csrf,
        uuid:this.script.uuid,
        main_script:this.script.main_script,
        sub_script:this.script.sub_script,
        title:this.script.title,
        save:doSave
      })).data
      clearInterval(timer)

      if (this.script.uuid != res.uuid && res.uuid) {
        history.pushState({}, res.title, '/'+res.uuid);

      }
      this.script = res
    }
  },
  components: {
    VueCodemirror,
    splitPane
  },
  async mounted() {
    this.auth = (await axios.get('/me')).data
    if (location.pathname !== '/') {
      this.script = (await axios.get('/script'+location.pathname).catch(function () {
        confirm('script is not found')
        location.href = '/'
      })).data
    } else {
      this.script = (await axios.get('/script/default-script')).data
    }

    window.addEventListener('keydown', (event) => {
      if (event.key === 's' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        this.save()
      }
    })
  }
}
</script>

<style>
  .buttons {
    float: right;
    margin-right: 16px;
  }
  .title {
    float: left;
  }
  .nav {
    float: right;
    padding: 0;
    margin: 0;
  }
  .nav li {
    list-style: none;
    float: left;
    margin: 0 32px;
    color: white;
  }

  .nav a {
    text-decoration: none;
    color:white;
  }
  .nav a:visited {
    color: white;
  }
  .result {
    height: calc(100% - 32px);
    width: 100%;
    border: none;
    box-sizing: border-box;
    padding: 16px;
    background: #272822;
    resize: none;
    white-space: pre;
    color: white;
    outline: none;

  }
  .buttons a{
    margin: 0 12px;
    text-decoration: underline;
    color: white;
  }
  .script_title {
    width: 50%;
    float: right;
    height: 32px;
    box-sizing: border-box;
    background: rgba(255,255,255, 0.2);
    border: 1px solid black;
    outline: none;
    caret-color: white;
    color: white;
    padding-left: 16px;
  }
  .script_title::placeholder {
    color: #ccc;
  }
  .setting {
    background: #272822;
    color: white;
    height: calc(100% - 32px);
    box-sizing: border-box;
    padding: 16px;
  }
  .logo {
    color: red;
    font-size: 1.4em;
    text-decoration: none;
    font-weight: bold;
  }
  .header {
    height: 64px;
    width: 100%;
    background: #222;
    color: white;
    line-height: 64px;
    padding-left: 16px;
    box-sizing: border-box;
  }
  .main {
    height: calc(100% - 64px);
  }
  #app {
   height: 100%;
   overflow: hidden;
  }
  .vue-codemirror,.height100{
   height: 100%;
  }
  .CodeMirror {
   height: calc(100% - 32px) !important;
  }
  .filename {
   width: 100%;
   height: 32px;
   font-size: 14px;
   line-height: 32px;
   padding-left: 16px;
   background: #330000;
   color: white;
   box-sizing: border-box;
  }
  html,body {
    padding: 0;
    margin: 0;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue